import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';

import {HttpClient} from '@angular/common/http';
import {Router} from '@angular/router';
import {GridService} from 'app/core-ui/abstract/basegrid/grid.service';
import {ConfigService} from 'app/core-ui/abstract/services/config.service';
import {EventsEmitterService} from 'app/core-ui/abstract/services/emitter.service';
import {LogService} from 'app/core-ui/abstract/services/log.service';
import {catchError, map} from 'rxjs/operators';

@Injectable()
export class ResendInvitationService extends GridService {
  constructor(
    http: HttpClient,
    configService: ConfigService,
    eventsEmitterService: EventsEmitterService,
    router: Router,
    logger: LogService,
  ) {
    super(http, configService, eventsEmitterService, router, logger, 'ResendInvitationService');
  }
  getPKs(params: any): Observable<any> {
    let serviceUrl = this.baseUrl + this.serviceName + '/getPKs?' + this.urlParamsToString(params);
    return this.request(serviceUrl).pipe(map(super.extractData), catchError(super.handleError));
  }
  resendEmail(params) {
    let serviceUrl = this.baseUrl + this.serviceName + '/resendInvitation';
    return this.request(serviceUrl, this.setPostParams(params)).pipe(
      map(super.extractData),
      catchError(super.handleError),
    );
  }
  downloadExcel(): Observable<any> {
    let serviceUrl = this.baseUrl + this.serviceName + '/getDocSamples?langId=1&val=EXCEL_SAMPLE';
    return this.request(serviceUrl).pipe(map(super.extractData), catchError(super.handleError));
  }
  downloadBankExcel(): Observable<any> {
    let serviceUrl =
      this.baseUrl + this.serviceName + '/getDocSamples?langId=1&val=BANK_EXCEL_SAMPLE';
    return this.request(serviceUrl).pipe(map(super.extractData), catchError(super.handleError));
  }
  rejectInvitations(invitationIds: any[], rejectionReason: string): Observable<any> {
    let serviceUrl = this.baseUrl + this.serviceName + '/rejectInvitations?invitationIds=' + invitationIds + '&rejectionReason=' + rejectionReason;
    return this.request(serviceUrl, this.setPostParams(invitationIds)).pipe(
      map(super.extractData),
      catchError(super.handleError),
    );
  }
}
